import { Box, Button, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store/store';
import { setReportAnIssueMode } from 'store/ticket-service/ticketSlice';

import { NamespacesList } from 'core/enums/common';

import { SharedModal } from 'components/shared/Modal';

import { ReactComponent as Success } from 'assets/icons/success.svg';

type SuccessBugReportModalProps = {
	handleCloseModal: () => void;
	resetForm: () => void;
};

export const SuccessBugReportModal: FC<SuccessBugReportModalProps> = ({
	handleCloseModal,
	resetForm,
}) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const dispatch = useAppDispatch();
	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		handleCloseModal();
		setOpen(false);
	};

	return (
		<SharedModal isOpen={open} handleClose={handleClose}>
			<Box
				className="not-rtl-able"
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					alignSelf: 'center',
					width: { xs: '100%', sm: '438px' },
					margin: '48px 0',
				}}
			>
				<Success />

				<Typography variant="h3" sx={{ fontSize: '24px', fontWeight: '700', marginTop: '32px' }}>
					{modalTranslate('successfulIssueReportModal.title')}
				</Typography>

				<Typography
					sx={{
						color: '#9FA6B3',
						marginTop: '8px',
						textAlign: 'center',
					}}
				>
					{modalTranslate('successfulIssueReportModal.description')}
				</Typography>

				<Typography
					sx={{
						color: '#4786FF',
						marginTop: { xs: '16px', sm: '32px' },
						cursor: 'pointer',
					}}
					onClick={() => {
						resetForm();
						handleClose();
					}}
				>
					{modalTranslate('successfulIssueReportModal.confirm')}
				</Typography>

				<Button
					sx={{
						height: '44px',
						width: { xs: '90%', sm: '100%' },
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '16px',
						fontWeight: '700',
						marginTop: '24px',
					}}
					variant="contained"
					color="primary"
					onClick={() => {
						dispatch(setReportAnIssueMode(false));
						handleClose();
					}}
				>
					{modalTranslate('successfulIssueReportModal.cancel')}
				</Button>
			</Box>
		</SharedModal>
	);
};
